import { Table } from "antd";
import axios from "axios";
import Moment from "moment";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import Actions from "../../components/Common/Actions";
import Pagination from "../../components/Common/CommonPagination";
import Deletepopup from "../../components/Modal/Deletepopup";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import CTAHeader from "../CtaForm/CTAHeader";
import scroll from "../../assets/webp/scroll.webp";
const CTABanner = () => {
  const [showDelete, setShowDelete] = useState({ id: "", status: false });

  const [loader, setLoader] = useState(true);
  const { id } = useParams();

  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}cta-banner/ctabannerlist`,
      initialParams: {
        category: id,
      },
    });

  const handlePageChange = usePageChange(pagination, setPagination);
  const handleDelete = useDeleteHandler("cta-banner", fetchData, setShowDelete);

  useEffect(() => {
    setLoader(true)
    fetchData();
  }, [pagination.skip, pagination.limit, id]);

  const handleActive = (status, id) => {
    setLoader(true)
    axios
      .post(`${process.env.REACT_APP_API_URL}cta-banner/update-status/${id}`, {
        active: !status,
      })
      .then(() => {
        fetchData();
      });
  };

  const getsrcValue = (value) => {
    if (typeof value === "string" && value.length)
      return process.env.REACT_APP_API_URL + "cta-images/" + value;
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "serial",
      render: (_text, _record, index) => index + 1,
    },
    {
      title: "Banner Title",
      dataIndex: "bannerTitle",
      width: "300",
    },
    {
      title: "Image",
      dataIndex: "bannerImage",
      render: (img) => (
        <img
          src={getsrcValue(img)}
          style={{
            width: "100px",
            height: "50px",
            marginTop: "2%",
            marginBottom: "5%",
          }}
          alt="banner"
        />
      ),
    },
    {
      title: "Total Prospects",
      dataIndex: "totalProspects",
    },
    {
      title: "Total Clicks",
      dataIndex: "totalClicks",
    },
    {
      title: "Upload Time",
      dataIndex: "createdAt",
      render: (createdAt) => Moment(createdAt).format("DD MMMM YYYY LT"),
    },
    {
      title: "Status",
      dataIndex: "active",
      render: (active, record) => (
        <Actions
          isActive={true}
          recordActiveStatus={active}
          onClickActive={() => handleActive(active, record._id)}
        />
      ),
    },
    {
      title: "Actions",
      dataIndex: "_id",
      render: (_id) => (
        <Actions
          isDelete={true}
          onClickDelete={() => setShowDelete({ id: _id, status: true })}
        />
      ),
    },
  ];

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <>
      <div>
        <CTAHeader type="Banner" />
        {!loader ? (
          <>
            <Table
              bordered
              dataSource={records}
              columns={columns}
              pagination={false}
              rowKey="_id"
              className="mx-3 pt-2 table-scrollable medicineList_table"
              scroll={{ x: "max-content" }}
            />
          </>
        ) : (
          <div className="d-flex justify-content-center">
            <img src={scroll} width={150} alt="loader" />
          </div>
        )}
      </div>
      <div className="mt-4 col d-flex align-items-center pagination justify-content-between admin-pagination">
        <div className="border border-danger bg-bg-light px-2 py-1 rounded">
          Total {id}: {totalCount}
        </div>
        {totalCount > pagination.limit && (
          <Pagination
            skip={pagination.skip}
            limit={pagination.limit}
            total={totalCount}
            onPageChange={(selected) => handlePageChange({ selected })}
          />
        )}
      </div>
      {showDelete.status && (
        <Deletepopup
          handleDelete={handleDelete}
          id={showDelete?.id}
          isCloseModalEnable={true}
          handleClose={() => setShowDelete({ id: "", status: false })}
        />
      )}
    </>
  );
};
export default CTABanner;
